// const $window = $(window);
// let windowWidth = $window.width();
// var _isTest = false;

// // メディアクエリ
// let mql = window.matchMedia('screen and (max-width: 1024px)');

//pageTop
import {pageTop} from "../include/module";
pageTop();

//anchorLink
import {anchorLink} from "../include/module";
anchorLink();

//preload
import {preload} from "../include/module";
preload();

//toggleHeader
import {toggleHeader} from "../include/module";
toggleHeader();


$(window).on('load' , function() {

  tabSwitching();

  scrollAnime();
});

// ------------------------------------------------------------------------
// tabSwitching
// ----- BOTH
// ------------------------------------------------------------------------
const tabSwitching = () => {

  $(document).on('click','[data-song]', function(){
    var targetid = $(this).data('song');
    var idx=$('.tab-item').index(this);
    $(this).addClass('current').siblings('.tab-item').removeClass('current');
    $(this).closest('.tab').next('.panel').find('.panel-item').removeClass('is-show is-animation');
    $('.panel-item').eq(idx).addClass('is-show');
    setTimeout(function(){
      $('.panel-item').eq(idx).addClass('is-animation');
    }, 50);
  });
};


// ------------------------------------------------------------------------
// scrollAnime
// ----- BOTH
// ------------------------------------------------------------------------
const scrollAnime = () => {

  const controller = new ScrollMagic.Controller();

  //ページトップ出現
  const scene = new ScrollMagic.Scene({
    triggerElement:'.index-Story',
    triggerHook: 1,
    offset: '80'
  })
  .setClassToggle('#st-Top', 'st-Top-Show')
  .addTo(controller);

};



// WEBPACK FOOTER //
// ./src/assets/js/music/script.js